import { useRouter } from "next/navigation";
import { useState } from "react";
import UserService from "@/service/userService";
import { toastStore } from "@/store/toastStore";

/**
 * ヘッダー コンポーネントで使う Hook を提供します。
 */
export default function useHeader() {
	const [isOpen, setIsOpen] = useState(false);
	const { openToast } = toastStore();

	const router = useRouter();
	const handleMenu = () => {
		setIsOpen(!isOpen);
		// router.refresh();
	};

	const handleMenuClose = () => {
		setIsOpen(false);
	};

	const logout = async () => {
		const userService = new UserService();
		const response = await userService.Logout();
		response.when({
			onSuccess: () => {
				router.push("/");
				router.refresh();
			},
			onFailure: () => {
				openToast({
					type: "error",
					title: "ログアウトに失敗しました。",
					description: "再度ログアウトを行ってください。",
				});
			},
		});
	};

	return { isOpen, handleMenu, handleMenuClose, logout };
}
